import React from "react";
import { Grid, Typography, Button, Container } from "@mui/material";
import InfoImage from "../../assets/Info-13.svg";
import ButtonImg from "../../assets/monitor.png";
import Coin from "../../assets/coin.png";
import GraphImage from "../../assets/Group 6-1.png";
import "./index.css";

export default function index() {
  return (
    <>
      <Container>
        <Grid container className="main-container-section-4">
          <Grid item className="main-text-div-22">
            <Typography className="main-text-1">
              Terra Treasury offers
              <Typography className="main-text-2">
                frictionless access
              </Typography>
            </Typography>
            <Grid>
              <Typography className="section-text">
                Earn 34.87% APY in just three simple steps.
                <Typography className="section-text"></Typography>
                Start you savings journey now and grow your portfolio today.
              </Typography>
            </Grid>
            <Grid className="main-buttons-div-section-4">
              <Button className="main-button-section">
                <Typography className="main-button-section">
                  Learn More
                </Typography>
                <img src={InfoImage} />
              </Button>
              <Button className="header-button">
                <img src={Coin} />
                <Typography className="header-button-text">Save Now</Typography>
              </Button>
            </Grid>
          </Grid>
          <Grid item className="graphy-img-div">
            <img src={GraphImage} />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
